import { render, staticRenderFns } from "./TepGraficaTurnosOpAreaInternos.vue?vue&type=template&id=33f71481"
import script from "./TepGraficaTurnosOpAreaInternos.vue?vue&type=script&lang=js"
export * from "./TepGraficaTurnosOpAreaInternos.vue?vue&type=script&lang=js"
import style0 from "./TepGraficaTurnosOpAreaInternos.vue?vue&type=style&index=0&id=33f71481&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports